import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type { ChannelType } from 'uplisting-frontend/models/channel-connection';
import type AirbnbOfficialLinkAdapter from 'uplisting-frontend/adapters/airbnb-official-link';
import type BookingDotComLinkAdapter from 'uplisting-frontend/adapters/booking-dot-com-link';

// A channel link's id points at a row on its channel's own link endpoint.
const LINK_ADAPTERS: Partial<
  Record<ChannelType, 'airbnb-official-link' | 'booking-dot-com-link'>
> = {
  airbnb: 'airbnb-official-link',
  booking_dot_com: 'booking-dot-com-link',
};

export default class ChannelLinkRepositoryService extends BaseRepositoryService<
  ModelRegistry['channel-link']
> {
  recordName = 'channel-link';
  implementMethods = [];

  public async unlink(link: ModelRegistry['channel-link']): Promise<void> {
    const { type } = link.channelConnection;
    const adapterName = LINK_ADAPTERS[type];

    try {
      if (!adapterName) {
        throw new Error(`${type} links have no unlink endpoint`);
      }

      const adapter = this.store.adapterFor(adapterName) as
        | AirbnbOfficialLinkAdapter
        | BookingDotComLinkAdapter;

      await adapter.unlink(String(link.linkId));
    } catch (err) {
      this.sentry.captureException(err, {
        tags: { repository: this.recordName, operation: 'unlink' },
      });

      throw err;
    }

    link.unloadRecord();
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/channel-link': ChannelLinkRepositoryService;
  }
}
